import { uploadFileToBase64String } from './../../../../../common/utils/utils';
import { ICreateEquipamentoMedicaoUseCase } from "../../../presentation/useCases/create/create_equipamento_medicao_use_case";
import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

/**
 * CreateEquipamentoMedicaoUseCase
 */

export class CreateEquipamentoMedicaoUseCase
  implements ICreateEquipamentoMedicaoUseCase {
  constructor(private readonly repository: IEquipamentoMedicaoRepository) {
  }
  async createEquipamentoMedicao(
    idObra: number | null,
    equipamento?: string,
    idFuncionario?: number,
    idFuncionarioMonit?: number,
    descResponsavelMonit?: string,
    responsavelCadastradoMonit?: string,
    frequenciaVerificao?: number,
    idFuncionarioResp?: number,
    descResponsavelResp?: string,
    responsavelCadastradoResp?: boolean,
    dataVerificacao?: Date,
    dataProxVerificacao?: Date,
    tipoMonitoramento?: string,
    arquivo?: File,
    nomeArquivo?: string,
    arquivo1?: File,
    nomeArquivo1?: string,
    observacao?: string,
    idCentroCusto?: number,
    idFornecedorMonit?: number,
    tipoVerificacao?: boolean,
    tipoRespEquipamento?: number,
    tipoCaliVeriiPor?: number,
    tipoFrequenciaData?: number
  ): Promise<number> {
    // if (idObra === undefined) throw new Error("Falha ao obter id da obra.");

    return await this.repository.createEquipamentoMedicao(
      idObra,
      equipamento,
      idFuncionario,
      idFuncionarioMonit,
      descResponsavelMonit,
      responsavelCadastradoMonit,
      frequenciaVerificao,
      idFuncionarioResp,
      descResponsavelResp,
      responsavelCadastradoResp,
      dataVerificacao,
      dataProxVerificacao,
      tipoMonitoramento,

      arquivo ? await uploadFileToBase64String(arquivo) : undefined,
      nomeArquivo,
      arquivo1 ? await uploadFileToBase64String(arquivo1) : undefined,
      nomeArquivo1,

      observacao,
      idCentroCusto,
      idFornecedorMonit,
      tipoVerificacao,
      tipoRespEquipamento,
      tipoCaliVeriiPor,
      tipoFrequenciaData,

    );
  }
}
